var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download"},[_c('a',{staticClass:"temp_xls",attrs:{"href":"javascript:;"},on:{"click":_vm.download}},[_vm._v("重新下载导入模板")])])}
var staticRenderFns = []

export { render, staticRenderFns }